import { atom } from 'jotai';

export const $AdditionalParams = atom<Record<string, unknown>>({});
